export const NO_STALE_TIME = 0;
export const SEVEN_SECONDS = 7 * 1000;
export const ONE_MINUTE = 60 * 1000;
export const FIVE_MINUTES = 5 * 60 * 1000;
export const TEN_MINUTES = 10 * 60 * 1000;
export const FIFTEEN_MINUTES = 15 * 60 * 1000;
export const THIRTY_MINUTES = 30 * 60 * 1000;
export const ONE_HOUR = 60 * 60 * 1000;
export const TWO_HOURS = 2 * 60 * 60 * 1000;
